import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Markdown from './Markdown';


const COLUMNS = {
  '1N': 1,
  '2N': 2,
  '3N': 3,
  '4N': 4,
};

const Box = styled.div`
  > .markdown {
    margin: 3rem 0 0 0;

    > p {
      font-size: 2.2rem;
      font-weight: 600;
    }
  }

  > ul {
    margin: 4rem 0 0 0;
    padding: 0;
    list-style-type: none;
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: repeat(${props => COLUMNS[props.$question?.display] || 1}, 1fr);

    > li {
      margin: 0;
      padding: 1.5rem;
      border: 1px solid ${props => props.theme.colors.gray};
      cursor: pointer;
      font-size: 1.6rem;
      border-radius: 4px;
      ${props => (props.$timeout || props.$stopped) && 'opacity: .5;'}
      ${props => (props.$timeout || props.$stopped) && 'pointer-events: none;'}

      &:hover {
        ${props => !props.$timeout && `border: 1px solid ${props.theme.colors.blue};`}
      }

      &.selected {
        opacity: 1;
        border: 1px solid ${props => props.theme.colors.blue};
      }

      > .markdown {
        margin-top: 0;

        > p {
          font-size: 1.8rem;
          font-weight: 600;
        }
      }
    }
  }
`;

const QuestionChoice = ({ question, timeout, stopped, onAnswered }) => {
  const [choice, setChoice] = useState(null);
  const readonly = timeout || stopped;

  useEffect(() => {
    setChoice(null);
  }, [question]);

  const handleChoice = (eid) => {
    if (timeout || stopped) {
      return;
    }
    setChoice(eid);
    onAnswered({ choice_choice: eid });
  };

  return (
    <Box $question={question} $timeout={timeout} $stopped={stopped}>
      <Markdown className="markdown" value={question.choiceText} />
      <ul>
        {question.choices.map(item => (
          <li
            key={item.eid}
            onClick={!readonly ? () => handleChoice(item.eid) : undefined}
            className={choice === item.eid ? 'selected' : ''}
          >
            <Markdown className="markdown" value={item.text} />
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default QuestionChoice;
